// extracted by mini-css-extract-plugin
export default {"tongue":"Tongue_tongue__xc3Ha"};